var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBigWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "72px",
    viewBox: "0 0 82 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orders_ErrorModal",
    transform: "translate(-471.000000, -1483.000000)",
    stroke: "#F79737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(245.000000, 1397.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_failure",
    transform: "translate(227.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-3062-+-Stroke-3063-+-Stroke-3064"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,47 L40,26",
    id: "Stroke-3062",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73663136,66.9984149 L38.7688653,2.99208466 L38.7688653,2.99208466 C39.3220255,2.03600537 40.5455058,1.70937488 41.5015851,2.26253504 C41.804388,2.43772816 42.0559416,2.68928174 42.2311347,2.99208466 L79.2633686,66.9984149 L79.2633686,66.9984149 C79.8165288,67.9544942 79.4898983,69.1779745 78.533819,69.7311347 C78.229404,69.9072605 77.8839281,70 77.5322339,70 L3.46776606,70 L3.46776606,70 C2.36319656,70 1.46776606,69.1045695 1.46776606,68 C1.46776606,67.6483058 1.56050554,67.3028299 1.73663136,66.9984149 Z",
    id: "Stroke-3063",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,59 C38.896,59 38,58.104 38,57 C38,55.896 38.896,55 40,55 C41.104,55 42,55.896 42,57 C42,58.104 41.104,59 40,59 Z",
    id: "Stroke-3064",
    fill: "#F79737"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigWarning);
export default __webpack_public_path__ + "static/media/icon-big-warning.e7ac401faa38e0fbd3ca4ff733312b7a.svg";
export { ForwardRef as ReactComponent };